function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNextcladeLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 68.146 68.234"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-152.458 -303.27)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.104,
  height: 13.229,
  x: 171.095,
  y: 390.222,
  rx: 2.646,
  ry: 3,
  style: {
    fill: "#e29d39",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 40.908,
  height: 13.229,
  x: 153.458,
  y: 357.188,
  rx: 2.646,
  ry: 2.912,
  style: {
    fill: "#e56a2f",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 29.104,
  height: 13.229,
  x: 153.458,
  y: 343.958,
  rx: 2.646,
  ry: 3,
  style: {
    fill: "#cbb742",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 26.458,
  height: 13.229,
  x: 182.563,
  y: 343.958,
  rx: 2.646,
  ry: 3,
  style: {
    fill: "#e29d39",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.583,
  height: 13.229,
  x: 209.021,
  y: 343.958,
  rx: 2.823,
  ry: 3,
  style: {
    fill: "#e68634",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.938,
  height: 13.229,
  x: 153.458,
  y: 330.729,
  rx: 3,
  ry: 3,
  style: {
    fill: "#92bc63",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 58.208,
  height: 13.229,
  x: 161.396,
  y: 330.729,
  rx: 2.95,
  ry: 2.912,
  style: {
    fill: "#b9bc4a",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 21.167,
  height: 13.229,
  x: 153.458,
  y: 317.5,
  rx: 3,
  ry: 3,
  style: {
    fill: "#60aa9e",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 52.917,
  height: 13.229,
  x: 153.458,
  y: 304.271,
  rx: 3,
  ry: 3,
  style: {
    fill: "#549db2",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 13.229,
  height: 13.229,
  x: 206.375,
  y: 304.271,
  rx: 2.586,
  ry: 3,
  style: {
    fill: "#60aa9e",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 44.979,
  height: 13.229,
  x: 174.625,
  y: 317.5,
  rx: 3,
  ry: 3,
  style: {
    fill: "#6eb389",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 25.238,
  height: 13.229,
  x: 194.366,
  y: 357.276,
  rx: 3,
  ry: 3,
  style: {
    fill: "#e04929",
    fillOpacity: 1,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
})));
export default SvgNextcladeLogo;